import type { FeedContextValue } from "./FeedContextValue"

export const defaultFeedContextValue: FeedContextValue = {
  getIndexItem: () => undefined,
  updateIndexSize: () => {},
}
